import HTTP_METHOD from "enums/HTTP_METHOD";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";
import useProject from "hooks/useProject";
import IndividualItemResponse from "types/IndividualItemResponse";
import UserDto from "types/UserDto";

const DEFAULT_PARAMS = {
  includeQuestions: false,
  sort: "title",
  size: 9999,
  page: 0,
};

export default function useDeleteScript() {
  const { projectId } = useProject();
  const { write, ...rest } = useApiWrite();

  const deleteScript = (
    scriptId: string,
  ): Promise<IndividualItemResponse<UserDto>> =>
    write<IndividualItemResponse<UserDto>>({
      url: endpoints.deleteScript(projectId, scriptId),
      method: HTTP_METHOD.DELETE,
      mutateOnSuccess: [
        endpoints.getAllScript(projectId, { ...DEFAULT_PARAMS }),
      ],
    }).then(({ data }) => data);

  return { deleteScript, ...rest };
}
